module.exports = __webpack_public_path__ + "static/media/cognitive.8e638fc4.png";